import { Ability, Action, Subject } from '../ability';

class PronunciationAbility implements Ability {
  subject: Subject;
  action: Action;

  constructor(action: Action) {
    this.subject = 'Pronunciations';
    this.action = action;
  }
}

export const PronunciationViewAbility = new PronunciationAbility(
  'viewProjectPronunciation' as Action,
);

export const PronunciationApproveAbility = new PronunciationAbility(
  'approveProjectPronunciation' as Action,
);

export const PronunciationRejectAbility = new PronunciationAbility(
  'rejectProjectPronunciation' as Action,
);

export const PronunciationEditAbility = new PronunciationAbility(
  'editProjectPronunciation' as Action,
);

export const fileAbilities = [
  PronunciationViewAbility,
  PronunciationApproveAbility,
  PronunciationRejectAbility,
  PronunciationEditAbility,
];

export default fileAbilities;
